export default "/screen-recorder";
